export default "__VITE_ASSET__1829c252__"